module.exports = __webpack_public_path__ + "static/img/fuwu.a05af7ed.png";